import { jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from '../style/labelAndLegend.module.scss.js';

const { componentTestLabel } = getTestLabels('Label');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=2718-4192&node-type=section&t=L12XIxh9aK1lGzgC-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Form/Label/Label.tsx)
 *
 * @param {ReactChild} children - (optional, but silly without it) Can be any ReactNode/HTML element,
 *   but **should** only be valid phrasing content allowed in an HTML `label`
 *   (see [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label#technical_summary)).
 * @param {boolean} isRequired - (optional) **DEPRECATED Will be removed in a future version.
 *   Use `optionalText` when the field is optional instead of `isRequired` when the field is required.**.
 *   When set to `true`, a red asterisk (`*`) is displayed after the label text.
 * @param {string} labelPosition - (optional) **DEPRECATED (will be removed in a future version)**.
 *  One of `normal` (default) or `side`. Controls the label's text-align.
 * @param {string} optionalText - (optional) Text to show if filling in the associated field is optional.
 *   In English, this can be the word "optional" but this word **must be translated into the current language**.
 */
const Label = forwardRef((props, ref) => {
    const { children, className, isRequired, labelPosition = 'normal', optionalText, ...otherProps } = props;
    return (jsxs("label", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-label'], {
            [style['z-label--required']]: isRequired && !optionalText,
            [style['z-label--side']]: labelPosition === 'side',
        }, className), children: [children, ' ', optionalText && (jsxs("span", { className: style['z-label__optional'], children: ["(", optionalText, ")"] }))] }));
});
Label.displayName = 'Label';

export { Label };
//# sourceMappingURL=Label.js.map
